import { render, staticRenderFns } from "./CustomersLeadsDetail.vue?vue&type=template&id=53894df0&scoped=true"
import script from "./CustomersLeadsDetail.vue?vue&type=script&lang=js"
export * from "./CustomersLeadsDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomersLeadsDetail.vue?vue&type=style&index=0&id=53894df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53894df0",
  null
  
)

export default component.exports